import { useId } from "react";
import { twMerge } from "tailwind-merge";

interface ICheckboxProps {
  gtmId: string;
  children?: React.ReactNode;
  size?: "small" | "large";
  checked?: boolean;
  shape?: "round" | "square";
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isFlex?: boolean;
}

const Checkbox = (props: ICheckboxProps) => {
  const {
    children,
    size = "small",
    checked = false,
    shape,
    className,
    onChange,
    gtmId,
  } = props;
  const key = useId();

  return (
    <div
      className={`${props.isFlex ? "flex" : "inline-flex"} items-center`}
      data-gtm-id={gtmId}
    >
      <label
        className={twMerge(
          "relative flex items-center rounded-sm cursor-pointer",
          children && "mr-[12px]",
          className
        )}
        htmlFor={key}
      >
        <input
          id={key}
          type="checkbox"
          className={twMerge(
            "before:content[''] peer relative h-[15px] w-[15px] cursor-pointer appearance-none rounded-sm border transition-all border-primary-500 checked:bg-primary-500",
            size === "large" && "h-[20px] w-[20px]",
            shape === "round" && "rounded-full checked:bg-primary-700"
          )}
          checked={checked}
          onChange={onChange}
        />
        <div className="absolute text-white transition-opacity opacity-0 pointer-events-none peer-checked:opacity-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={twMerge(
              "w-[15px] h-[12px]",
              size === "large" && "w-[20px] h-[17px]",
              shape === "round" && size === "large" && "w-[20px] h-[14px]"
            )}
            viewBox="0 0 20 20"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="1"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            ></path>
          </svg>
        </div>
      </label>
      <label
        className="flex-1 mt-px text-base font-normal text-black cursor-pointer"
        htmlFor={key}
      >
        {children && <span className="text-base">{children}</span>}
      </label>
    </div>
  );
};

export default Checkbox;
